import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api.js';

// ── Conexión de WhatsApp por 360dialog (2026-08-19) ──────────────────────────
// El cliente es titular de su cuenta y su número. Acá solo se pega la clave.

export interface WhatsappConnection {
  connected: boolean;
  status: 'connected' | 'disconnected' | 'unknown';
  phoneNumber: string | null;
  error: string | null;
  checkedAt: string | null;
  /** Coexistence: días desde la última señal de actividad en la app del
   *  teléfono. Meta desactiva la cuenta a los `limitDays`. */
  daysSinceAppActivity: number | null;
  limitDays: number;
  warnDays: number;
}

export function useWhatsappConnection() {
  return useQuery<WhatsappConnection>({
    queryKey: ['whatsapp-connection'],
    queryFn: () => api.get('/api/settings/whatsapp'),
    staleTime: 30_000,
  });
}

export function useConnectWhatsapp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (apiKey: string) => api.post<WhatsappConnection>('/api/settings/whatsapp/connect', { apiKey }),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['whatsapp-connection'] }),
  });
}

export function useDisconnectWhatsapp() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ ok: boolean }>('/api/settings/whatsapp/disconnect', {}),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['whatsapp-connection'] }),
  });
}

/** "Ya abrí la app" — corrige la estimación del reloj de 13 días. */
export function useMarkAppOpened() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => api.post<{ ok: boolean }>('/api/settings/whatsapp/app-opened', {}),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ['whatsapp-connection'] }),
  });
}
